import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FaDownload } from 'react-icons/fa';
import './Catalogue.css';
import { useTranslation } from 'react-i18next';

const CatalogueDownload = () => {
 const { t } = useTranslation();
const { i18n } = useTranslation();

  return (
    <div
      style={{
        backgroundColor: '#5d655a',
        color: 'white',
        padding: '80px 0',
        width: '100vw',
        marginLeft: 'calc(-50vw + 50%)', // Forces true full-width from center-aligned parent
      }}
    >
      <Container fluid className="px-5">
        <Row className="align-items-center justify-content-between">
          <Col md={8}>
          <h1
  style={{
    fontSize: '2rem',
    fontWeight: '700',
    margin: 0,
  }}
>{t("Catalogue.heading")} 
</h1>


          </Col>

          <Col md={4} className="text-md-end mt-4 mt-md-0">
          <a
  href="./catalogue-lc.pdf"
  download
  style={{
    backgroundColor: '#336734',
    border: 'none',
    fontWeight: 'bold',
    padding: '10px 16px',
    // margin: '-35px 80px',
    fontSize: '1rem',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: '#FFFFF',
    textDecoration: 'none',
    borderRadius: '5px',
    width: '260px'
  }}
>
  <FaDownload />
  {t("Catalogue.download")} 
</a>

          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CatalogueDownload;
